import * as React from 'react';
import { htmlEncode } from '../../lib/utils/htmlEncode';
import { replaceArrayBuffersWithStrings } from '../../lib/utils/arrayBuffersToBase64';
import cssClassNames from "./PrettyPrintedJsonObjectView.module.css";

export const prettifyJsonString = (json: string): string => {
	const spanWithClassAndMatch = (cssClass: string, match: string) => 
		`<span class="${ cssClass }">${ htmlEncode(match) }</span>`;
	return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
		const spanWithClass = (cssClass: string) => spanWithClassAndMatch(cssClass, match);
			if (/^"/.test(match)) {
				if (/:$/.test(match)) {
					return spanWithClass("jsonKey");
				} else {
					if ( (match.startsWith("\"{") && match.endsWith("}\"")) ||
						( (match.startsWith("\"[") && match.endsWith("]\"")) )
					) {
						try {
							const jsonParsedString = JSON.parse(match);
							const jsonParsedObject = JSON.parse(jsonParsedString);
							if (jsonParsedObject != null) {
								return `<span class='jsonStringify'>JSON.stringify</span>(${
									prettifyJsonString(
										JSON.stringify(jsonParsedObject, null, '\t')
									).replaceAll("<br/>", `<br/>${"&nbsp;".repeat(12)}`)
								})`;
							}
						} catch { /* ignore error */ }
					}
					return spanWithClass("jsonString");
				}
			} else if (/true|false/.test(match)) {
				return spanWithClass(match.toLocaleLowerCase() === 'true' ? "jsonTrue" : "jsonFalse");
			} else if (/null/.test(match)) {
				return spanWithClass("jsonNull");
			}
			return spanWithClass("jsonNumber");
		})
		.replaceAll('\t','&#32;&nbsp;')
		.replaceAll('\n','<br/>');
}



export const PrettyPrintedJsonObjectView = ({ objectToPrettyPrintAsJson }: React.PropsWithChildren<{ objectToPrettyPrintAsJson: object; }>) => {
	const json = JSON.stringify(replaceArrayBuffersWithStrings(objectToPrettyPrintAsJson), null, '\t');
	const prettyJson = prettifyJsonString(json);
	return (
		<div className={cssClassNames.PrettyPrintedJson} dangerouslySetInnerHTML={{ __html: prettyJson }} />
	);
};
